const PackageTypes = Object.freeze({
    HORIZON_BASIC: 'Horizon Basic',
    HORIZON_CONTROL: 'Horizon Control',
    HORIZON_ADVANCE: 'Horizon Advance',
    HORIZON_BASIC_OFFLINE: 'Horizon Basic Offline'
});

export default PackageTypes;
